import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Error } from '../../../Data/error.dto';
import { Albums, Folder, LikedImageType } from '../../../Data/album.dto';

import { getFolderLikedImageAPIV2 } from '../../ApiCalls/Dashboard/FolderApi';
import { showErrorToast } from '../../../components/atoms/Utlis/Toast';

export interface FolderState {


    error: Error;
    isError: boolean;
    loading: boolean;
    isUpdate: boolean;
    currentFolder?: Folder;
    isFolderChange: boolean;
    currentFolders: Folder[];
    likeImages: {
        data: LikedImageType[],
        isLoading: boolean,
    }
    success: boolean;

}

const initialState: FolderState = {

    error: {},
    isError: false,
    likeImages: {
        data: [],
        isLoading: false,
    },
    loading: false,
    isUpdate: true,
    isFolderChange: true,
    success: false,
    currentFolders: [],
}



const folderSlice = createSlice({
    name: 'folder',
    initialState,
    reducers: {
        setError(state, action: PayloadAction<any>) {
            state.isError = true;
            state.error = action.payload;
            state.loading = false;

        },
        clearError(state) {
            state.isError = false;
            state.error = {};
            state.loading = false;
        },

        setIsFolderChanged(state, action: PayloadAction<boolean>) {
            state.isFolderChange = action.payload;
        },

        removeCurrentFolder(state) {
            delete state.currentFolder;
        },


        setCurrentFolder(state, action: PayloadAction<Folder>) {
            state.currentFolder = action.payload;
        },


    },
    extraReducers: (builder) => {
        builder.addCase(getFolderLikedImageAPIV2.pending, (state, action: PayloadAction<any>) => {
            state.likeImages.isLoading = true;
            state.likeImages.data = [];
        }).addCase(getFolderLikedImageAPIV2.fulfilled, (state, action: PayloadAction<any>) => {
            state.likeImages.isLoading = false;
            state.likeImages.data = action.payload?.liked_images ?? []
        }).addCase(getFolderLikedImageAPIV2.rejected, (state, action: PayloadAction<any>) => {
            state.likeImages.isLoading = false;
            showErrorToast("Failed to load liked images!!")
            state.likeImages.data = [];
        })
    },
});

export const { setError, clearError, setCurrentFolder, removeCurrentFolder } = folderSlice.actions;


export default folderSlice.reducer;
